import portfolioService from '@/services/portfolioService';

export default {
  namespaced: true,
  state: {
    portfolios: [],
    count: 0,
  },
  mutations: {
    setPortfolios(state, portfolios) {
      state.portfolios = portfolios;
    },
    setCount(state, count) {
      state.count = count;
    },
    addPortfolio(state, portfolio) {
      state.portfolios.push(portfolio);
      state.count++;
    },
    updatePortfolio(state, updatedPortfolio) {
      const index = state.portfolios.findIndex(p => p.id === updatedPortfolio.id);
      if (index !== -1) state.portfolios.splice(index, 1, updatedPortfolio);
    },
    deletePortfolio(state, portfolioId) {
      state.portfolios = state.portfolios.filter(p => p.id !== portfolioId);
      state.count = Math.max(0, state.count - 1);
    },
  },
  actions: {
    async fetchPortfolios({ commit, rootState }) {
      try {
        const userEmail = rootState.auth.user?.email;
        const response = await portfolioService.getAllPortfolios(userEmail);
        commit('setPortfolios', response.data);
        // Also fetch count when fetching all, or trust the length? 
        // Since we are adding a separate endpoint, we should use it if we want the "true" total count even if we don't fetch all portfolios (e.g. pagination in future). 
        // For now, fetching count separately is safer if the getAll doesn't return everything or if we just want to be consistent.
      } catch (error) {
        console.error('Error fetching portfolios:', error);
      }
    },
    async fetchCount({ commit, rootState }) {
      try {
        const userEmail = rootState.auth.user?.email;
        if (!userEmail) return;
        const response = await portfolioService.getPortfolioCount(userEmail);
        commit('setCount', response.data);
      } catch (error) {
        console.error('Error fetching portfolio count:', error);
      }
    },
    async createPortfolio({ commit, rootState }, portfolio) {
      try {
        const portfolioData = {
          ...portfolio,
          userId: rootState.auth.user?.email
        };
        const response = await portfolioService.createPortfolio(portfolioData);
        commit('addPortfolio', response.data);
      } catch (error) {
        console.error('Error creating portfolio:', error);
      }
    },
    async updatePortfolio({ commit, rootState }, portfolio) {
      try {
        const portfolioData = {
          ...portfolio,
          userId: rootState.auth.user?.email
        };
        const response = await portfolioService.updatePortfolio(portfolioData.id, portfolioData);
        commit('updatePortfolio', response.data);
      } catch (error) {
        console.error('Error updating portfolio:', error);
      }
    },
    async deletePortfolio({ commit }, portfolioId) {
      try {
        await portfolioService.deletePortfolio(portfolioId);
        commit('deletePortfolio', portfolioId);
      } catch (error) {
        console.error('Error deleting portfolio:', error);
      }
    },
  },
};
